// extracted by mini-css-extract-plugin
export default {"wrapper":"mT-z","availablePromoMessagesLabel":"nT-z","promoMessageList":"oT-z","promoMessage":"pT-z","appliedPromoMessage":"qT-z","promoMessageAmount":"rT-z"};